<template>
	<div class="user-info-mask" @click="$emit('close')">
		<div class="user-info" :style="{ left: pos.x + 'px', top: pos.y + 'px' }" @click.stop>
			<div class="user-info-box">
				<div class="avatar">
					<head-image :name="user.nickName" :url="user.headImageThumb" :size="70" :online="user.online"
						radius="10%" @click.native="showFullImage()"> </head-image>
				</div>
				<div>
					<el-descriptions :column="1" :title="user.userName" class="user-info-items">
						<el-descriptions-item label="聊天号">{{ user.userCode }}
						</el-descriptions-item>
						<el-descriptions-item label="昵称">{{ user.nickName }}
						</el-descriptions-item>
						<el-descriptions-item label="签名">{{ user.signature }}
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</div>
			<el-divider content-position="center"></el-divider>
			<div class="user-btn-group">
				<!-- 当前用户 -->
				<el-button v-show="isCurrentUser" type="primary" @click="editSignature()">修改签名</el-button>
				<!-- 好友 -->
				<el-button v-show="isFriend && !isCurrentUser" type="primary" @click="onSendMessage()">发消息</el-button>
				<el-button v-show="isFriend && !isCurrentUser" type="default" @click="editRemark()">修改备注</el-button>
				<el-button v-show="isFriend && !isCurrentUser" type="default" @click="onMoveToGroup()">移动到分组</el-button>
				<!-- 非好友 -->
				<el-button v-show="!isFriend && !isCurrentUser" type="primary" @click="onAddFriend()">加为好友</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import HeadImage from './HeadImage.vue'

export default {
	name: "userInfo",
	components: {
		HeadImage
	},
	data() {
		return {}
	},
	props: {
		user: {
			type: Object
		},
		pos: {
			type: Object
		}
	},
	methods: {
		editSignature() {
			this.$prompt('请输入您的个性签名', '修改个性签名', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValue: this.user.signature
			}).then(({ value }) => {
				this.$http({
					url: "/user/signature",
					method: "put",
					data: {
						signature: value
					}
				}).then(() => {
					this.$message.success("个性签名修改成功");
					this.$store.commit("updateUserInfo", { signature: value });
					this.$emit("close");
				}).catch((error) => {
					this.$message.error("个性签名修改失败: " + (error.message || "未知错误"));
				});
			}).catch(() => {});
		},
		editRemark() {
			this.$prompt('请输入好友备注', '修改备注', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValue: this.getFriendRemark()
			}).then(({ value }) => {
				this.$http({
					url: "/friend/remark",
					method: "put",
					data: {
						friendId: this.user.id,
						remarkName: value
					}
				}).then(() => {
					this.$message.success("备注修改成功");
					
					// 更新好友列表中的备注名
					this.$store.commit("updateFriendRemark", { 
						id: this.user.id, 
						remarkName: value 
					});
					
					// 更新聊天列表中的显示名称
					const friend = {
						id: this.user.id,
						nickName: this.user.nickName,
						headImageThumb: this.user.headImageThumb,
						remarkName: value
					};
					this.$store.commit("updateChatFromFriend", friend);
					
					this.$emit("close");
				}).catch((error) => {
					this.$message.error("备注修改失败: " + (error.message || "未知错误"));
				});
			}).catch(() => {});
		},
		onMoveToGroup() {
			// 先获取分组列表
			this.$http.get('/friend/group/list').then((groups) => {
				if (!groups || groups.length === 0) {
					this.$message.warning('暂无分组，请先创建分组');
					return;
				}
				
				// 构建选项HTML
				let optionsHtml = groups.map(group => 
					`<option value="${group.id}">${group.name}</option>`
				).join('');
				
				this.$confirm(
					`<div style="text-align: left;">
						<p>请选择要移动到的分组：</p>
						<select id="groupSelect" style="width: 100%; padding: 8px; border: 1px solid #dcdfe6; border-radius: 4px;">
							<option value="">请选择分组</option>
							${optionsHtml}
						</select>
					</div>`, 
					'移动到分组', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						dangerouslyUseHTMLString: true,
						beforeClose: (action, instance, done) => {
							if (action === 'confirm') {
								const selectedGroupId = document.getElementById('groupSelect').value;
								if (!selectedGroupId) {
									this.$message.warning('请选择分组');
									return;
								}
								
								// 执行移动操作
								this.$http.post('/friend/group/move', null, {
									params: {
										friendId: this.user.id,
										groupId: selectedGroupId
									}
								}).then(() => {
									this.$message.success('移动成功');
									this.$emit("friend-group-changed");
									this.$emit("close");
									done();
								}).catch((error) => {
									this.$message.error('移动失败: ' + (error.message || '未知错误'));
								});
							} else {
								done();
							}
						}
					}
				).catch(() => {});
			}).catch((error) => {
				this.$message.error('获取分组列表失败: ' + (error.message || '未知错误'));
			});
		},
		getFriendRemark() {
			let friend = this.$store.state.friendStore.friends.find(f => f.id === this.user.id);
			return friend ? friend.remarkName || '' : '';
		},
		onSendMessage() {
			let user = this.user;
			// 如果是好友，优先使用备注名称
			let displayName = user.nickName;
			if (this.isFriend) {
				let friend = this.$store.state.friendStore.friends.find((f) => f.id == user.id);
				displayName = friend && friend.remarkName ? friend.remarkName : user.nickName;
			}
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: displayName,
				headImage: user.headImage,
			};
			this.$store.commit("openChat", chat);
			this.$store.commit("activeChat", 0);
			if (this.$route.path != "/home/chat") {
				this.$router.push("/home/chat");
			}
			this.$emit("close");
		},
		onAddFriend() {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: this.user.id
				}
			}).then((data) => {
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: this.user.id,
					nickName: this.user.nickName,
					headImage: this.user.headImageThumb,
					online: this.user.online
				}
				this.$store.commit("addFriend", friend);
			})
		},
		showFullImage() {
			if (this.user.headImage) {
				this.$store.commit("showFullImageBox", this.user.headImage);
			}
		}
	},
	computed: {
		isFriend() {
			let friends = this.$store.state.friendStore.friends;
			let friend = friends.find((f) => f.id == this.user.id);
			return friend != undefined;
		},
		isCurrentUser() {
			return this.user.id === this.$store.state.userStore.userInfo.id;
		}
	}
}
</script>

<style lang="scss">
.user-info-mask {
	background-color: rgba($color: #000000, $alpha: 0);
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
}

.user-info {
	position: absolute;
	width: 300px;
	background-color: white;
	box-shadow: var(--im-box-shadow);
	border-radius: 4px;
	padding: 15px;

	.user-info-box {
		display: flex;
		align-items: center;

		.user-info-items {
			margin-left: 10px;
			white-space: nowrap;
			overflow: hidden;

			.el-descriptions__header {
				margin-bottom: 5px;
			}

			.el-descriptions__title {
				font-size: 18px;
			}

			.el-descriptions-item__cell {
				padding-bottom: 1px;
			}
		}
	}

	.el-divider--horizontal {
		margin: 18px 0;
	}

	.user-btn-group {
		text-align: center;
	}
}
</style>
